import React, { useState } from "react";
import { useTheme } from "../config/ThemeContext";

export default function CreateTeamSection({ onCreate }) {
  const theme = useTheme();
  const initial = {
    name: "", code: "", pool: "", headCoach: "", assistantCoach: "", assistantCoach2: "",
    manager: "", doctor: "", therapist: "", mainColor: "", secondaryColor: "",
    thirdColor: "", fourthColor: ""
  };
  const [formData, setFormData] = useState(initial);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onCreate(formData);
    setFormData(initial);
  };

  return (
     <div className={`bg-white rounded-xl shadow-md p-6 mb-8 mt-6 border-t-4 ${theme.neutral.border}`}>
      <h2 className="text-xl font-semibold mb-4">Create New Team</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {Object.keys(formData).map(field => (
          <div key={field}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {field.charAt(0).toUpperCase() + field.slice(1)}
            </label>
            <input
              type="text"
              value={formData[field]}
              onChange={e => handleChange(field, e.target.value)}
              placeholder={`Enter ${field}`}
              className="w-full px-3 py-2 border rounded focus:ring focus:border-indigo-300"
            />
          </div>
        ))}
      </div>
      <div className="mt-4 flex justify-end">
        <button
          onClick={handleSubmit}
          className={theme.buttons.primary}
        >
          Create Team
        </button>
      </div>
    </div>
  );
}
